module.exports = __webpack_public_path__ + "static/img/map.feb2ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.jpg
// module id = aZiJ
// module chunks = 1